module.exports = __webpack_public_path__ + "assets/close-darkBlue-ef012b.svg";